import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#2C2D33",
      d: "M16 4H8C5.8 4 4 5.8 4 8v8c0 2.2 1.8 4 4 4h8c2.2 0 4-1.8 4-4V8c0-2.2-1.8-4-4-4m2.666 12A2.67 2.67 0 0 1 16 18.667H8A2.67 2.67 0 0 1 5.333 16V8A2.67 2.67 0 0 1 8 5.333h8A2.67 2.67 0 0 1 18.666 8z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2C2D33",
      d: "M16.334 8.667a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12 8a4 4 0 1 0-.001 7.999 4 4 0 0 0 0-7.999m0 6.667a2.667 2.667 0 1 1 0-5.334 2.667 2.667 0 0 1 0 5.334"
    }, null, -1)
  ])))
}
export default { render: render }